import * as React from "react"
import { 
  ArrayInput, 
  TextInput,
  SimpleFormIterator
} from "react-admin"
import { Grid } from "@mui/material"
const SpecificationsTab = () => {
  return (
    <Grid container width={{ xs: "100%", xl: 800 }} spacing={2}>
      <Grid item xs={12}>
        <ArrayInput source="specifications" label="規格選項">
            <SimpleFormIterator getItemLabel={index => `#${index + 1}`}> 
            <TextInput source="name" label="選項名稱" inputProps={{ maxLength: 20 }} />
            </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  )
}

export default SpecificationsTab;